import {ChangeEvent, useRef} from 'react';
import {SearchIconWrapper, SearchInputContainer, StyledSearchIcon, StyledSearchTextField} from './SearchInput.styled';
import {t} from "i18next";
import FieldHelpSuffix from "../FieldHelpSuffix";
import {IconButton, InputAdornment, Tooltip} from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';

interface SearchInputProps {
    onChange: (value: string) => void;
    placeholder?: string;
    value?: string;
    ariaLabel?: string;
}

const SearchInput = ({
     onChange,
     placeholder,
     value = '',
     ariaLabel,
 }: SearchInputProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const defaultPlaceholder = t('searchInput.placeholder') as string;
    const helpText = t('searchInput.help') as string;
    const clearText = t('searchInput.clear') as string;

    const resolvedPlaceholder = placeholder ?? defaultPlaceholder;
    const resolvedAriaLabel = ariaLabel ?? defaultPlaceholder;

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value);
    };

    const handleSearchInputContainerClick = () => {
        inputRef.current?.focus();
    };

    return (
        <SearchInputContainer onClick={handleSearchInputContainerClick}>
            <StyledSearchTextField
                fullWidth
                variant="outlined"
                placeholder={resolvedPlaceholder}
                value={value}
                onChange={handleInputChange}
                inputRef={inputRef}
                inputProps={{
                    role: 'searchbox',
                    'aria-label': resolvedAriaLabel,
                }}
                InputProps={{
                    startAdornment: (
                        <SearchIconWrapper>
                            <StyledSearchIcon/>
                        </SearchIconWrapper>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            {value && (
                                <Tooltip
                                    title={clearText}
                                    enterTouchDelay={50}
                                    leaveTouchDelay={4000}
                                >
                                    <IconButton onClick={() => onChange('')} aria-label={clearText}>
                                        <ClearIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            )}
                            <FieldHelpSuffix
                                asAdornment
                                title={helpText}
                                ariaLabel={helpText}
                            />
                        </InputAdornment>
                    ),
                }}
            />
        </SearchInputContainer>
    );
};

export default SearchInput;
